import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const ChangePasswordPage = () => (
  <section className="sales-portal-page" aria-labelledby="sales-change-password-title">
    <h4 id="sales-change-password-title">Change Password</h4>
    <Alert variant="info">
      Password management is handled by the Production Portal Microsoft sign-in provider.
    </Alert>
    <Button as={Link} to="/sales/dashboard" variant="primary">Back to Sales Portal</Button>
  </section>
);

export const ResetPasswordPage = () => (
  <section className="sales-portal-page" aria-labelledby="sales-reset-password-title">
    <h4 id="sales-reset-password-title">Reset Password</h4>
    <Alert variant="info">
      User password resets are handled by the Production Portal Microsoft sign-in provider.
    </Alert>
    <Button as={Link} to="/sales/admin/users" variant="primary">Back to Users</Button>
  </section>
);

export const SalesUnauthorizedPage = () => (
  <section className="sales-portal-page" aria-labelledby="sales-unauthorized-title">
    <h4 id="sales-unauthorized-title">Access Denied</h4>
    <Alert variant="warning">
      You do not have access to this Sales Portal area.
    </Alert>
    <Button as={Link} to="/sales/dashboard" variant="primary">Back to Sales Portal</Button>
  </section>
);
